function withMountWhenInView(BaseClass, defaultOptions = { threshold: [0, 1] }) {
  class WithMountWhenInView extends BaseClass {
    static config = {
      ...BaseClass.config,
      name: `${BaseClass.config.name}WithMountWhenInView`,
      options: {
        ...BaseClass.config?.options || {},
        intersectionObserver: Object
      }
    };
    __isVisible = false;
    __observer;
    constructor(element) {
      super(element);
      this.__observer = new IntersectionObserver(
        (entries) => {
          const isVisible = entries.reduce((acc, entry) => acc || entry.isIntersecting, false);
          if (this.__isVisible !== isVisible) {
            this.__isVisible = isVisible;
            if (isVisible) {
              this.$mount();
            } else {
              setTimeout(() => this.$destroy());
            }
          }
        },
        {
          ...defaultOptions,
          ...this.$options.intersectionObserver
        }
      );
      this.__observer.observe(this.$el);
      this.$on("terminated", () => {
        this.__observer.disconnect();
      });
    }
    $mount() {
      if (this.__isVisible) {
        super.$mount();
      }
      return this;
    }
  }
  return WithMountWhenInView;
}
export {
  withMountWhenInView
};
//# sourceMappingURL=withMountWhenInView.js.map
